import styled from "styled-components";
import { Link as LinkS } from "react-scroll";

export const FooterContainer = styled.footer`
  background: #101522;
  width: 100%;
  overflow-x: hidden;
`;

export const FooterWrap = styled.div`
  padding: 48px 24px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  max-width: 1100px;
  margin: 0 auto;
  width: 100%;
  box-sizing: border-box;

  @media screen and (max-width: 768px) {
    padding: 40px 20px;
  }

  @media screen and (max-width: 480px) {
    padding: 32px 16px;
  }
`;

export const FooterLinksWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  gap: 32px;
  margin-bottom: 40px;

  @media screen and (max-width: 820px) {
    flex-direction: column;
    gap: 40px;
    align-items: center;
  }

  @media screen and (max-width: 480px) {
    gap: 32px;
    margin-bottom: 32px;
  }
`;

export const FooterLinkItems = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  text-align: left;
  box-sizing: border-box;
  color: #f0f00;
  flex: 1;

  ${(props) =>
    props.description &&
    `
    flex: 2;
    
    @media screen and (max-width: 820px) {
      flex: 1;
      width: 100%;
      text-align: center;
      align-items: center;
    }
  `}

  @media screen and (max-width: 820px) {
    width: 100%;
    align-items: center;
    text-align: center;
  }

  @media screen and (max-width: 480px) {
    padding: 0;
    width: 100%;
  }
`;

export const FooterLinkTitle = styled.h1`
  font-size: 18px;
  margin-bottom: 16px;
  font-weight: 600;
  color: #f0f00;

  @media screen and (max-width: 768px) {
    font-size: 20px;
    margin-bottom: 20px;
  }

  @media screen and (max-width: 480px) {
    font-size: 18px;
    margin-bottom: 16px;
  }
`;

export const FooterLinkHead = styled.p`
  font-size: 16px;
  margin-bottom: 16px;
  line-height: 1.6;
  color: #f0f00;

  @media screen and (max-width: 1024px) {
    font-size: 15px;
    line-height: 1.5;
  }

  @media screen and (max-width: 768px) {
    font-size: 18px;
    line-height: 1.5;
    max-width: 600px;
  }

  @media screen and (max-width: 480px) {
    font-size: 18px;
    line-height: 1.4;
  }
`;

export const FooterLink = styled(LinkS)`
  color: #f0f00;
  text-decoration: none;
  margin-bottom: 0.75rem;
  font-size: 16px;
  cursor: pointer;
  transition: 0.3s ease-out;
  display: inline-block;

  &:hover {
    color: #84ba3f;
    transform: translateX(5px);
  }

  @media screen and (max-width: 820px) {
    font-size: 20px;
    margin-bottom: 0.875rem;

    &:hover {
      transform: translateY(-2px);
    }
  }

  @media screen and (max-width: 480px) {
    font-size: 20px;
    margin-bottom: 0.75rem;
  }
`;

export const SocialMedia = styled.section`
  max-width: 1000px;
  width: 100%;
  margin-top: 20px;

  @media screen and (max-width: 768px) {
    margin-top: 20px;
  }

  @media screen and (max-width: 480px) {
    margin-top: 16px;
  }
`;

export const SocialMediaWrap = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 1100px;
  margin: 0 auto;
  width: 100%;
  gap: 24px;

  @media screen and (max-width: 820px) {
    flex-direction: column-reverse;
    gap: 24px;
    text-align: center;
  }

  @media screen and (max-width: 480px) {
    gap: 20px;
  }
`;

export const SocialLogo = styled(LinkS)`
  color: #f0f00;
  justify-self: start;
  cursor: pointer;
  text-decoration: none;
  font-size: 1.5rem;
  display: flex;
  align-items: center;
  margin-bottom: 0;
  font-weight: bold;
  gap: 8px;
  transition: 0.3s ease-out;

  &:hover {
    color: #84ba3f;
    transform: scale(1.05);
  }

  @media screen and (max-width: 768px) {
    font-size: 1.3rem;
  }

  @media screen and (max-width: 480px) {
    font-size: 1.2rem;
  }
`;

export const WebsiteRights = styled.small`
  color: #fff;
  margin-bottom: 16px;
  font-size: 14px;
  letter-spacing: 1px;

  @media screen and (max-width: 768px) {
    font-size: 12px;
    letter-spacing: 0.5px;
  }
`;

export const SocialIcons = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 180px;
  gap: 16px;

  @media screen and (max-width: 480px) {
    width: 160px;
    gap: 12px;
  }
`;

export const SocialIconLink = styled.a`
  color: #fff;
  font-size: 24px;
  transition: 0.3s ease-out;

  &:hover {
    color: #84ba3f;
    transform: translateY(-3px);
  }

  @media screen and (max-width: 768px) {
    font-size: 22px;
  }

  @media screen and (max-width: 480px) {
    font-size: 20px;
  }
`;
